


































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import PemantauanTtvHarianStore from "@/store/modules/PemantauanTtvHarianStore";
import PemantauanTtvHarianService from "@/services/PemantauanTtvHarian";
import GrafikTtvDewasaChart from "@/components/chart/GrafikTtvDewasaChart.vue";
import CardPemantauanTtvInput from "./grafikttvdewasa/CardPemantauanTtvInput.vue";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import moment from "moment";

@Component({
  components: {
    GrafikTtvDewasaChart,
    CardPemantauanTtvInput
  }
})
export default class GrafikTtvDewasaPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: string;
  @Prop({ default: false }) isActive!: boolean;

  dateFrom = "";
  dateTo = "";

  ttvHeaders = [
    { text: "Waktu", value: "waktu_periksa", width: "120px" },
    { text: "TD (mmHg)", value: "sistole" },
    { text: "Nadi", value: "frekuensi_nadi" },
    { text: "Suhu (\u00B0C)", value: "suhu_badan" },
    { text: "RR", value: "frekuensi_nafas" },
    { text: "SpO2 (%)", value: "saturasi_oksigen" },
    { text: "Kesadaran", value: "kesadaran" },
    { text: "EWS", value: "ews_skor", width: "60px" },
    { text: "O2 (% / L/m)", value: "suplemeno2" },
    { text: "Mobilisasi", value: "mobilisasi" }
  ];

  pemantauanHeaders = [
    { text: "Waktu", value: "tanggal", width: "100px" },
    { text: "O2 (L/m)", value: "oksigen_lpm" },
    { text: "Mobilisasi", value: "mobilisasi" },
    { text: "Cairan", value: "jenis_cairan" },
    { text: "Tpm", value: "tpm" },
    { text: "Transfusi", value: "jenis_transfusi" },
    { text: "Vol. (mL)", value: "volume_transfusi" },
    { text: "Makan", value: "jumlah_makan" },
    { text: "Minum", value: "volume_minum" },
    { text: "BAK", value: "volume_bak" },
    { text: "BAB", value: "bab" },
    { text: "Muntah", value: "volume_muntah" },
    { text: "IWL", value: "iwl" },
    { text: "Balance", value: "balance_cairan" },
    { text: "Aksi", value: "id", width: "50px" }
  ];

  get loadingTtv() {
    return TandaVitalStore.loading;
  }

  get ttvList() {
    return TandaVitalStore.list;
  }

  get filteredTtvList() {
    let list = [...this.ttvList].sort(
      (a, b) =>
        new Date(a.waktu_periksa).getTime() -
        new Date(b.waktu_periksa).getTime()
    );

    if (this.dateFrom) {
      list = list.filter(
        item => moment(item.waktu_periksa).format("YYYY-MM-DD") >= this.dateFrom
      );
    }
    if (this.dateTo) {
      list = list.filter(
        item => moment(item.waktu_periksa).format("YYYY-MM-DD") <= this.dateTo
      );
    }

    return list;
  }

  get pemantauanList() {
    return PemantauanTtvHarianStore.list;
  }

  get chartSeries() {
    return this.filteredTtvList.reduce(
      (result, item) => {
        result.suhu.push({
          x: new Date(item.waktu_periksa),
          y: item.suhu_badan
        });
        result.nadi.push({
          x: new Date(item.waktu_periksa),
          y: item.frekuensi_nadi
        });
        result.nafas.push({
          x: new Date(item.waktu_periksa),
          y: item.frekuensi_nafas
        });
        result.tensi.push({
          x: new Date(item.waktu_periksa),
          y: [item.sistole, item.diastole]
        });
        result.spo2.push({
          x: new Date(item.waktu_periksa),
          y: item.saturasi_oksigen
        });
        return result;
      },
      { suhu: [], nadi: [], nafas: [], tensi: [], spo2: [] } as any
    );
  }

  get dataSet() {
    return {
      labels: this.chartSeries.tensi.map(item =>
        moment(item.x).format("YYYY-MM-DD HH:mm")
      ),
      tensi: this.chartSeries.tensi.map(item => item.y),
      suhu: this.chartSeries.suhu.map(item => item.y),
      nadi: this.chartSeries.nadi.map(item => item.y),
      nafas: this.chartSeries.nafas.map(item => item.y),
      spo2: this.chartSeries.spo2.map(item => item.y)
    };
  }

  get chartWide(): number | undefined {
    return this.dataSet.labels.length > 20
      ? this.dataSet.labels.length * 40
      : undefined;
  }

  get chartWideStr(): string | undefined {
    return this.chartWide ? `${this.chartWide}px` : undefined;
  }

  get balancePerHari() {
    const grouped: { [key: string]: any[] } = {};
    this.pemantauanList.forEach(item => {
      if (!grouped[item.tanggal]) grouped[item.tanggal] = [];
      grouped[item.tanggal].push(item);
    });

    return Object.keys(grouped)
      .sort()
      .map(tanggal => {
        const items = grouped[tanggal];
        const totalIntake = items.reduce(
          (sum, i) => sum + (i.volume_minum || 0),
          0
        );
        const totalOutput = items.reduce(
          (sum, i) =>
            sum +
            (i.volume_bak || 0) +
            (i.volume_muntah || 0) +
            (i.volume_drainase || 0) +
            (i.iwl || 0),
          0
        );
        return {
          tanggal,
          totalIntake,
          totalOutput,
          balance: totalIntake - totalOutput
        };
      });
  }

  @Watch("isActive")
  onActiveChanged(val: boolean) {
    if (val) {
      this.loadData();
    }
  }

  mounted() {
    if (this.isActive) {
      this.loadData();
    }
  }

  loadData() {
    TandaVitalStore.getByRegister(this.register);
    this.loadPemantauanData();
  }

  loadPemantauanData() {
    PemantauanTtvHarianStore.getByRegister(this.register);
  }

  filterData() {
    // data sudah difilter oleh computed filteredTtvList
  }

  resetFilter() {
    this.dateFrom = "";
    this.dateTo = "";
  }

  formatWaktu(waktu: string) {
    return moment(waktu).format("DD/MM HH:mm");
  }

  parseTensi(item: any) {
    if (item.periksa_tensi == 1 || item.periksa_tensi === null) {
      return item.tekanan_darah_text || `${item.sistole}/${item.diastole}`;
    } else if (item.periksa_tensi == 2) {
      return "Tidak terukur";
    } else if (item.periksa_tensi == 0) {
      return "Tidak diperiksa";
    }
    return "";
  }

  parseKesadaran(kesadaran: string) {
    if (!kesadaran) return "";
    return kesadaran === "cm" ? "CM" : kesadaran.charAt(0).toUpperCase() + kesadaran.slice(1);
  }

  parseEwsColor(item: any) {
    const lvl = item?.ews_level;
    if (lvl === "blue") return "#bbdefb";
    if (lvl === "rendah") return "#fff9c4";
    if (lvl === "sedang") return "#ffe0b2";
    if (lvl === "tinggi") return "#ffcdd2";
    return "";
  }

  parseMobilisasi(val: string | null) {
    if (!val) return "";
    const map: { [k: string]: string } = { B: "Baring", D: "Duduk", J: "Jalan" };
    return map[val] || val;
  }

  getLinkedOksigen(item: any) {
    const linked = this.pemantauanList.find(
      p => p.tanda_vital_id === item.id
    );
    return linked?.oksigen_lpm ?? item.suplemeno2 ?? "";
  }

  getLinkedMobilisasi(item: any) {
    const linked = this.pemantauanList.find(
      p => p.tanda_vital_id === item.id
    );
    return linked ? this.parseMobilisasi(linked.mobilisasi) : "";
  }

  async hapusPemantauan(id: number) {
    const confirm = confirmRemove("Data Pemantauan TTV");
    if (!confirm) return;

    try {
      const resp = await PemantauanTtvHarianService.destroy(id);
      appModule.NoticeDelayAlert(resp.data?.message || "Data berhasil dihapus");
      this.loadPemantauanData();
    } catch (err) {
      // error sudah ditangani di service
    }
  }

  cetakPdf() {
    const baseUrl = process.env.VUE_APP_API_URL || "";
    const url = `${baseUrl}/grafik-ttv/${this.register}/pdf`;
    window.open(url, "_blank");
  }
}
